/**
 * @deprecated ProspectContext has been deprecated. Please use UserAccountContext instead.
 */
export { default } from './ProspectContext';
